import { useIntl } from "react-intl";
import List from "app/pages/.shared/List";
import PropTypes from "prop-types";
import { memo } from "react";

const IncludedItemsList = ({ titleId, items }) => {
	const { formatMessage } = useIntl();
	return (
		<div className="included__list">
			<div className="included__title">
				<span>{`${formatMessage({ id: titleId })} :`}</span>
			</div>
			<List items={items} enableHTMLFormatting={true} />
		</div>
	);
};

IncludedItemsList.propTypes = {
	titleId: PropTypes.string.isRequired,
	items: PropTypes.array.isRequired,
};

export default memo(IncludedItemsList);
